import { BulkCreateMockupsResponse } from '@wix/ambassador-suppliershub-marketplace-mockups-v1-mockup/types';

export function bulkMockupResponseHasFailure(response: BulkCreateMockupsResponse | undefined): boolean {
  if (!response) {
    return true;
  }

  const totalFailures = response.bulkActionMetadata?.totalFailures ?? 0;
  if (totalFailures > 0) {
    return true;
  }

  return Boolean(response.results?.some((item) => item.itemMetadata?.success === false));
}

export function shouldStopMockupLoading(
  selectedProductIds: string[],
  mockups: Record<string, unknown>,
  bulkResponse?: BulkCreateMockupsResponse,
): boolean {
  if (selectedProductIds.every((productId) => productId in mockups)) {
    return true;
  }

  if (!bulkResponse?.results?.length) {
    return bulkResponse?.bulkActionMetadata?.totalSuccesses === 0;
  }

  return selectedProductIds.every((productId, index) => {
    if (productId in mockups) {
      return true;
    }

    const result = bulkResponse.results?.[index];
    return result?.itemMetadata?.success === false;
  });
}
